'use client';

import { useAccountSettings } from '@/hooks/useAccountSettings';
import { useAuthStore } from '@/store';
import { useEffect, useRef } from 'react';

export const AccountSettingsProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { getAccountSettingsApi } = useAccountSettings({
    loadGetAccountSettings: true,
  });
  const user = useAuthStore((state) => state.user);
  const setUser = useAuthStore((state) => state.setUser);
  const previousDataRef = useRef<string | null>(null);

  // Only fetch account settings if user is logged in
  useEffect(() => {
    if (user) {
      getAccountSettingsApi.refetch();
    }
  }, [user, getAccountSettingsApi]);

  // Update auth store when account settings change
  useEffect(() => {
    if (!user || !getAccountSettingsApi.data?.data) return;

    const { data } = getAccountSettingsApi.data;
    const currentData = JSON.stringify({
      name: data.name,
      profilePicture: data.profilePicture,
      areaOfInterest: data.areasOfInterest?.map((item) => item.name),
    });

    // Only update if data has actually changed
    if (currentData !== previousDataRef.current) {
      previousDataRef.current = currentData;
      setUser({
        ...user,
        fullName: data.name,
        profilePicture: data.profilePicture || null,
        areaOfInterest: data.areasOfInterest?.map((item) => item.name) || null,
      });
    }
  }, [getAccountSettingsApi.data, user, setUser]);

  return <>{children}</>;
};
